export default {"src":"/_next/static/media/finance.44a8eecf.svg","height":25,"width":26,"blurWidth":0,"blurHeight":0};